import { render, staticRenderFns } from "./Containers.vue?vue&type=template&id=201de0b3&scoped=true"
import script from "./Containers.vue?vue&type=script&lang=ts"
export * from "./Containers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201de0b3",
  null
  
)

export default component.exports